export const creativeCopy = {
  upload: '上传素材',
  generate: 'AI 生成素材',
  searchPlaceholder: '搜索素材名称',
  searchLabel: '搜索素材名称',
  suggestHint: '可搜索素材名、达人名或商品名',
  suggestEmpty: '素材库还是空的，先上传或生成一条',
  reset: '重置筛选',
  preview: '预览',
  useForAd: '用于广告',
  footnote: '上传与 AI 生成的素材自动入库；使用中的素材与达人授权素材不可删。',
  noMatches: '没有匹配的素材',
  noMatchesText: '换个筛选条件试试',
  empty: '素材库还是空的',
  emptyText: '上传一条素材，开始搭建你的素材库',
  filters: {
    source: '来源',
    kind: '类型',
    product: '商品',
    usage: '使用状态',
  },
  source: { all: '全部', ai: 'AI 生成', upload: '我的上传', kol: '达人授权' },
  kind: { all: '全部', video: '视频', image: '图片' },
  usage: { all: '全部', used: '使用中', unused: '未使用' },
  allProducts: '全部商品',
  aiDirections: ['通勤场景', '真实体验', '产品特写', '使用教程', '促销氛围'],
  uploadTooLarge: '文件超过 2MB，演示站只接受 2MB 以内的素材',
  storageNearlyFull: '本地演示存储快满了，先用左下角「重置演示数据」清一下再上传',
  uploadFailed: '本地存储写入失败，请重置演示数据后重试',
} as const

export async function uploadCreativeFile(file: File, productId: string): Promise<{ id?: string; error?: string }> {
  if (file.size > 2 * 1024 * 1024) return { error: creativeCopy.uploadTooLarge }
  const dataUrl = await new Promise<string>((resolve, reject) => {
    const reader = new FileReader()
    reader.onload = () => resolve(typeof reader.result === 'string' ? reader.result : '')
    reader.onerror = () => reject(reader.error ?? new Error('FileReader failed'))
    reader.readAsDataURL(file)
  }).catch(() => '')
  if (!dataUrl) return { error: creativeCopy.uploadFailed }
  const stored = window.localStorage.getItem(DEMO_STORAGE_KEY)?.length ?? 0
  if (stored + dataUrl.length * 1.05 > 4 * 1024 * 1024) return { error: creativeCopy.storageNearlyFull }
  const input: LibraryUploadInput = {
    name: file.name,
    kind: file.type.startsWith('video/') ? 'video' : 'image',
    dataUrl,
    productId,
  }
  try {
    return { id: useDemoStore.getState().uploadCreative(input) }
  } catch (error) {
    console.warn('uploadCreative failed', error)
    return { error: creativeCopy.uploadFailed }
  }
}
import { DEMO_STORAGE_KEY, useDemoStore } from '../../demo/store'
import type { LibraryUploadInput } from '../../demo/types'
